'use strict';

require('prop-types');
var React = require('react');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var PricingButton = require('./PricingButton.js');
var GridWithSpacing = require('../../common/GridWithSpacing.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function PricingSelection(_ref) {
  var subscriptionPlan = _ref.subscriptionPlan,
      usageBasedPlan = _ref.usageBasedPlan,
      freePlan = _ref.freePlan,
      selectedPlanId = _ref.selectedPlanId,
      _onClick = _ref.onClick;
  return React__default["default"].createElement(GridWithSpacing, {
    spacing: 16
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 6
  }, React__default["default"].createElement(PricingButton, {
    selected: selectedPlanId === subscriptionPlan.id,
    selectedPlan: subscriptionPlan,
    onClick: function onClick() {
      return _onClick(subscriptionPlan.id);
    }
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 6
  }, React__default["default"].createElement(PricingButton, {
    selected: selectedPlanId === usageBasedPlan.id,
    selectedPlan: usageBasedPlan,
    onClick: function onClick() {
      return _onClick(usageBasedPlan.id);
    }
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(PricingButton, {
    selected: selectedPlanId === freePlan.id,
    selectedPlan: freePlan,
    onClick: function onClick() {
      return _onClick(freePlan.id);
    }
  })));
}
PricingSelection.defaultProps = {
  onClick: function onClick() {}
};

module.exports = PricingSelection;
